import { Component, OnInit, ViewEncapsulation, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { PlaybookCommunicationService } from "../shared/services/playbook-communication.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import {
  Modalconfig,
  devicePixelRatio,
  DefaultLanguageId,
} from "src/app/shared/constants";
import { CommonHttpService } from "src/app/shared/services/common-http/common-http.service";
import { MessageService } from "src/app/shared/services/message/message.service";
import { trigger, style, transition, animate } from "@angular/animations";
import { Subscription } from "rxjs";
import { SessionStorageService } from "src/app/shared/services/session-storage/session-storage.service";
import {
  profileRoles,
  sessionProfile,
} from "src/app/shared/interfaces/sessionStorageModel";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { AddPageComponent } from "../shared/components/add-page/add-page.component";
import {
  Container,
  CopyContentExists,
  PlaybookLanguagesViewModel,
  PlaybookManifest,
} from "src/app/shared/model/container.models";
import { Playbook } from "src/app/shared/model/playbook.models";
import { RatingData } from "src/app/shared/model/resource-model";
import { RatingsComponent } from "src/app/shared/components/ratings/ratings.component";
import { CommunicationService } from "src/app/shared/services/communication/communication.service";
import { UtilService } from "../shared/services/utils/util.service";
import { SelectTranslationComponent } from "src/app/shared/components/translation-language/translation-language.component";
import { PlaybookCustomCssComponent } from "../shared/components/playbook-custom-css/playbook-custom-css.component";
import { Company } from "src/app/shared/interfaces/company";
import $ from "jquery";
import {
  cloneDeep,
  each,
  find,
  findIndex,
  forEach,
  merge,
  reject,
} from "lodash";
import * as screenfull from "screenfull";
import moment from "moment";
import { LocalStorageService } from "src/app/shared/services/local-storage/local-storage.service";
import { LocalStorageService as StorageService } from "ngx-webstorage";
import { DeviceDetectorService } from "ngx-device-detector";
import { SendIframeUrlService } from "src/app/shared/services/send-iframe-url/send-iframe-url.service";

@Component({
    selector: "app-playbook",
    templateUrl: "./playbook.component.html",
    styleUrls: ["./playbook.component.scss"],
    animations: [
        trigger("inOutAnimation", [
            transition(":enter", [
                style({ height: 0, opacity: 0 }),
                animate("0.4s ease-out", style({ height: 150, opacity: 1 })),
            ]),
            transition(":leave", [
                style({ height: 150, opacity: 1 }),
                animate("0.4s ease-in", style({ height: 0, opacity: 0 })),
            ]),
        ]),
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PlaybookComponent implements OnInit, OnDestroy {
  // this is just for testing get the playbook data from the backend;
  defaultLanguageId = DefaultLanguageId;
  playbook: Playbook = new Playbook();
  languageId: number;
  templateUrl: string;
  companyId: number;
  company: Company;
  playbookId: number;
  devicePixelRatio = devicePixelRatio;
  enableDisplay = false;
  first = true;
  container;
  customCss: any;
  coversColorsCss: any;
  customFonts: any;
  companyCustomCss: any;
  companyCustomFonts: any;
  resourceId: number;
  folderId: number;
  ckeStyle;
  vBuilderRedirectURl: string;
  playbookLanguages: Array<PlaybookLanguagesViewModel>;
  private subscribed: Subscription;
  private resRatingSubscription: Subscription;
  routeSubscription: Subscription;
  private bsModalSearchPlaybook: BsModalRef;
  private customCssRef: BsModalRef;
  private bsResRatingsModal: BsModalRef;
  private addPageModalRef: BsModalRef;
  private bsTranslationLanguageModal: BsModalRef;
  private resourceOnSubscriber: Subscription;
  private PageIdSubscriber: Subscription;
  private SectionIdSubscriber: Subscription;
  private playbookManifestSub: Subscription;
  private getCompanyData$: Subscription;
  private updateLanguageAfterPasteSub: Subscription;
  private resourceOn = false;
  private currentPageId: number = null;
  public previousPageId: number;
  public currentSectionId: number = null;
  private parentMap: string | number[] = "NOPARENT";
  loggedInProfile: sessionProfile;
  private eventSub: boolean;
  public isContentNotification = false;
  private contentId: number;
  private content: string;
  private isGetPlaybookData = false;
  navigationModal: BsModalRef;
  sidebarScrollOptions = {
    axis: "y",
    theme: "dark",
  };
  modalSubscription: Subscription[] = [];
  public screenfull = screenfull;
  private ratingsPopupOpened = false;
  private resRatingsPopupOpened = false;
  isCategoryId: string;
  coverImageStyle = {
    "background-image": ``,
  };
  pageFrom;
  treeViewJson = [];
  customIconsLoaded: number = null;
  selectedNavigationPage = {
    id: null,
    parentMap: null,
    page: null,
  };
  isShowPlaybookNavigation: boolean = false;
  deviceInfo = null;
  isMobile: boolean = false;
  isDesktopDevice: boolean;
  inMobileEditor: boolean = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: Location,
    private modalService: BsModalService,
    private commService: PlaybookCommunicationService,
    private commonHttpService: CommonHttpService,
    private sessionStorageService: SessionStorageService,
    private communicationService: CommunicationService,
    private utilService: UtilService,
    private messageService: MessageService,
    private localStorageService: LocalStorageService,
    private storage: StorageService,
    private deviceService: DeviceDetectorService,
    private sendIframeUrlService: SendIframeUrlService
  ) {
    this.checkDeviceType();
  }

  checkDeviceType() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }

  ngOnInit() {
    this.isCategoryId =
      this.localStorageService.getLocalStogareByKey("isCategoryRedirect");
    this.getPlaybook();
    this.getCompanyData();
    this.getplaybookCustomCss();
    this.undoRedoManifest();
    this.configureUpdateLanguagesOnPaste();
    // to get playbook manifest
    this.playbookManifestSub = this.commService
      .fetchPlaybookManifest()
      .subscribe((status) => {
        this.getPlaybook(status);
      });
    this.getSpace();
    $(window).resize(() => {
      this.getSpace();
    });
    this.storage
      .observe("isVideoPlaylist")
      .subscribe((isShowPlaybookNavigation) => {
        if (
          window !== window.parent &&
          window.location == window.parent.location
        ) {
          this.isShowPlaybookNavigation = isShowPlaybookNavigation;
        }
      });
    localStorage.setItem("isSearchOpenedEditor", "false");
    if (
      window === window.parent ||
      (window != window.parent && window.location != window.parent.location)
    ) {
      localStorage.setItem("mobileEditor", "false");
    }
  }

  /**
   * To fetch the playbook manifest
   */
  getPlaybook(isHrefUrl = PlaybookManifest.NONE) {
    this.loggedInProfile =
      this.sessionStorageService.getLoggedInProfileDetail();
    this.languageId =
      +this.activatedRoute.snapshot.queryParams.languageId ||
      this.defaultLanguageId;
    this.pageFrom = +this.activatedRoute.snapshot.queryParams.pageFrom || null;
    this.templateUrl =
      this.activatedRoute.snapshot.queryParams.templateUrl || null;
    this.vBuilderRedirectURl =
      this.activatedRoute.snapshot.queryParams.r || null;
    this.routeSubscription = this.activatedRoute.params.subscribe((route) => {
      this.playbookId = +route.playbookId;
      this.resourceId = +route.resourceId;
      this.folderId = +route.folderId;
    });
    if (this.playbookId) {
      this.commonHttpService
        .get<any>({
          uri: `/api/Playbooks/GetFullPlaybookManifest?playbookId=${
            this.playbookId
          }&languageId=${
            this.languageId === this.defaultLanguageId ? null : this.languageId
          }`,
        })
        .subscribe(
          (response) => {
            this.playbook = JSON.parse(response.json);
            this.getArrayIconStyle(this.playbook);
            this.companyId = this.playbook.companyId;

            document.title = this.playbook.title;
            if (!this.playbookLanguages) {
              this.getPlaybookLanguages();
              this.isCopyPageExists();
            }
            this.setPlaybookCss();
            this.initializeViewer(isHrefUrl);
            this.commService.Playbook = this.playbook;
            this.checkForRatings();
            this.commService.setCompanyId(this.companyId);
            this.communicationService.sendCompanyId(this.companyId);
            this.getContentNotification();
          },
          (error) => {
            if (error.includes("Playbook with the id")) {
              window.location.href = window.location.origin + "/account/access";
            }
          }
        );
    }
  }

  getContentNotification() {
    // to fetch content notification
    this.commonHttpService
      .get<any>({
        uri: `/api/ContentNotifications/GetContentNotificationByPlaybookId?playbookId=${this.playbookId}&profileId=${this.loggedInProfile.id}`,
        message: {
          showMessage: false,
        },
      })
      .subscribe(
        (response) => {
          if (response.id) {
            const currentDate = moment().startOf("day");
            const startDate = moment(response.startDate);
            const endDate = moment(response.endDate);
            if (
              currentDate.isSameOrAfter(startDate) &&
              currentDate.isSameOrBefore(endDate)
            ) {
              this.isContentNotification = true;
              this.contentId = response.id; // content id
              this.content = response.contents; // contents
            } else {
              this.isContentNotification = false;
            }
          } else {
            this.isContentNotification = false;
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  /**
   * To check if url contains '/ratings' for page rating
   */
  checkForRatings() {
    // To open container ratings modal when '/ratings' url is hit directly
    if (
      window.location.pathname.indexOf("/ratings") !== -1 &&
      !this.ratingsPopupOpened
    ) {
      this.ratingsPopupOpened = true;
      this.communicationService.setContRatingsStatus(true);
      return true;
    }
    return false;
  }

  /**
   * To check if url contains '/resourceRatings' for resource ratings
   */
  checkForResourceRatings() {
    // To open resource rating when redirected directly from URL
    if (
      window.location.pathname.indexOf("/resourceRatings") !== -1 &&
      !this.resRatingsPopupOpened
    ) {
      if (this.resourceId) {
        this.resRatingsPopupOpened = true;
        this.openResourceRatingsModal(this.resourceId);
        return true;
      }
      return false;
    } else if (
      window.location.pathname.indexOf("/folderRatings") !== -1 &&
      !this.resRatingsPopupOpened
    ) {
      if (this.folderId) {
        this.resRatingsPopupOpened = true;
        this.openResourceRatingsModal(this.folderId, 2);
        return true;
      }
      return false;
    }
    return false;
  }

  /**
   * To fetch playbook languages
   */
  getPlaybookLanguages() {
    this.commonHttpService
      .get({
        uri: `/api/Translation/GetPlaybookLanguages?playbookId=${this.playbookId}&companyId=${this.companyId}`,
      })
      .subscribe((response: Array<PlaybookLanguagesViewModel>) => {
        this.playbookLanguages = response;
        this.commService.setPlaybookLanguages(response);
        if (window.location.pathname.indexOf("selectTranslation") !== -1) {
          this.openLanguageModal();
        }
      });
  }

  configureUpdateLanguagesOnPaste() {
    this.updateLanguageAfterPasteSub = this.commService
      .getUpdateLanguagesAfterPasteContent()
      .subscribe((data) => {
        this.getPlaybookLanguages();
      });
  }

  /**
   * To set custom playbook styles
   */
  setPlaybookCss() {
    this.customCss = `<style> ${this.playbook.customCss} </style>`;
    this.coversColorsCss = `<style> ${this.playbook.coversColorsCss} </style>`;
    if (this.playbook.enableCustomFonts && !this.playbook.isEmbededFonts) {
      // for embedded link
      this.customFonts = this.playbook.customFonts;
    } else if (
      this.playbook.enableCustomFonts &&
      this.playbook.isEmbededFonts
    ) {
      // for font-face
      this.customFonts = `<style> ${this.playbook.customFonts} </style>`;
    }
    // to handle company custom css
    if (this.playbook.company) {
      this.companyCustomCss = `<style> ${this.playbook.company.customCss} </style>`;
      if (
        this.playbook.company.enableCustomFonts &&
        !this.playbook.company.isEmbededFonts
      ) {
        // for embedded link
        this.companyCustomFonts = this.playbook.company.customFonts;
      } else if (
        this.playbook.company.enableCustomFonts &&
        this.playbook.company.isEmbededFonts
      ) {
        // for font-face
        this.companyCustomFonts = `<style> ${this.playbook.company.customFonts} </style>`;
      }
    }
  }
  getplaybookCustomCss() {
    this.commService.getplaybookCustomCss().subscribe((playbookCustomCss) => {
      this.customCss = `<style> ${playbookCustomCss} </style>`;
    });
  }
  // To handle inline ckeditor position on change
  getSpace() {
    const r = $("body").width() - $(".playbook-box").width();
    if (!isNaN(r)) {
      this.ckeStyle = `<style>.cke_float { right: ${
        r / 2 + 60
      }px !important; } </style>`;
    }
  }

  /**
   * To initialize the viewer first time after playbook manifest api gets called
   */
  initializeViewer(isHrefUrl) {
    let currentPage: number;
    let href: string;
    let pages: Array<string>;
    let ids: Array<string | number>;
    this.subscribed = this.activatedRoute.paramMap.subscribe(async (x) => {
      currentPage = +x.get("pageId");
      if (isHrefUrl === PlaybookManifest.PAGE_TEMPLATE) {
        href = window.location.href;
        pages = href.split("page/");
        if (pages.length > 1) {
          ids = pages[1].split("/");
          currentPage = +ids[0];
          if (ids.length > 2) {
            this.currentSectionId = +ids[2];
          }
        }
      }
      if (currentPage) {
        this.commService.resetToggleResourcesOn();
        if (isHrefUrl !== PlaybookManifest.PAGE_TEMPLATE) {
          this.currentSectionId = +x.get("sectionId");
        }
        this.setParentMapForPage(this.playbook, currentPage);
        if (this.parentMap === "NOPARENT") {
          this.router.navigate(["/playbookeditor/" + this.playbook.id]);
        }
        this.previousPageId = this.currentPageId;
        this.currentPageId = currentPage;
      }
      this.ChildrenContainerTurnOff(this.playbook);
      this.turnOnContainers(this.playbook);
      this.commService.setCurrentIds(this.currentPageId, this.currentSectionId);
      this.commService.setCurrentPageData = this.utilService.getCurrentPageData(
        this.playbook,
        this.currentPageId
      );
    });

    // This subscriber will toggle resource drawer
    this.resourceOnSubscriber = this.commService
      .getResourcesOn()
      .subscribe((isOn) => {
        if (isOn) {
          this.resourceOn = isOn;
        } else {
          setTimeout(() => {
            this.resourceOn = isOn;
          }, 500);
        }
      });

    /**
     * This will change pages based on changed page Id which will be pushed to observer
     */
    this.PageIdSubscriber = this.commService
      .getCurrentPageId()
      .subscribe((pageId) => {
        this.commService.sendCurrentVideoId(null);
        this.commService.clearSelectedContentBlockId();
        if (pageId === -1 || this.isGetPlaybookData) {
          this.playbook = this.commService.Playbook;
        }
        setTimeout(() => {
          if (pageId == null) {
            this.ChildrenContainerTurnOff(this.playbook);
            this.previousPageId = this.currentPageId;
            this.currentPageId = pageId;
          } else if (pageId !== this.currentPageId || this.isGetPlaybookData) {
            this.isGetPlaybookData = false;
            this.previousPageId = this.currentPageId;
            if (pageId !== -1) {
              this.currentPageId = pageId;
            }
            this.setParentMapForPage(this.playbook, this.currentPageId);
            this.ChildrenContainerTurnOff(this.playbook);
            this.turnOnContainers(this.playbook);
          } else if (pageId != null) {
            this.currentPageId = pageId;
          }
          this.commService.resetToggleResourcesOn();
          $("#mainPlaybookSection").removeClass("swiped");
          $(".text-editor-menu-bar").hide();
          this.commService.setCurrentPageData =
            this.utilService.getCurrentPageData(
              this.playbook,
              this.currentPageId
            );
          this.getSpace();
        }, 100);
      });

    this.SectionIdSubscriber = this.commService
      .getCurrentSectionId()
      .subscribe((sectionId) => {
        this.currentSectionId = sectionId;
      });
  }
  // This function turns off children container of the container object which is passed to it.
  private ChildrenContainerTurnOff(obj) {
    if (obj.containers) {
      obj.containers.forEach((cont) => {
        if (cont.type === 1 && cont.on === true) {
          this.ChildrenContainerTurnOff(cont);
        } else {
          cont.on = false;
        }
      });
      obj.on = false;
    } else {
      obj.on = false;
    }
  }

  /**
   * This function sets parentMap for turning on the containers which are before the passed pageId in URL
   */
  private setParentMapForPage(obj: Playbook | Container, currPage) {
    obj.containers.forEach((cont) => {
      if (cont.type === 1 && cont.id === currPage) {
        this.parentMap = cont.parentMap;
        return;
      }
      if (cont.containers && cont.type === 1) {
        this.setParentMapForPage(cont, currPage);
      }
    });
  }

  /**
   * This function sets On property to true for the parents container of the passed pageId
   */
  private setParentContainersOn(obj: Playbook | Container, map) {
    obj.containers.forEach((cont) => {
      if (cont.id === map[0] && cont.type === 1) {
        cont.on = true;
        map = map.slice(1);
        if (map.length !== 0) {
          this.setParentContainersOn(cont, map);
        } else {
          cont.containers.forEach((container) => {
            if (container.id === this.currentPageId) {
              container.on = true;
              this.setPageSectionsOn(container);
            }
          });
        }
      }
    });
  }

  /**
   * This funtion sets section of the playbooks which are turned on currently
   */
  private setPageSectionsOn(container: Container) {
    let onFlag = null;
    if (!this.currentSectionId) {
      let sectionId = -1;
      const sections = container.containers.filter((a) => a.type === 2);
      const section = sections.sort((a, b) => {
        return a.orderBy - b.orderBy;
      })[0];
      // tslint:disable-next-line: max-line-length
      const ratingsPath = this.checkForRatings()
        ? "/ratings"
        : this.checkForResourceRatings()
        ? `/resource/${this.resourceId}/resourceRatings`
        : "";
      if (section) {
        sectionId = section.id;
        if (sectionId !== -1) {
          section.on = true;
          onFlag = -1;
          document.title = section.title;
          this.currentSectionId = sectionId;
          // tslint:disable-next-line: max-line-length
          const path = `/playbookeditor/${this.playbook.id}/page/${this.currentPageId}/section/${this.currentSectionId}${ratingsPath}?languageId=${this.languageId}`;
          this.location.go(
            `${path}${
              this.vBuilderRedirectURl ? "&r=" + this.vBuilderRedirectURl : ""
            }${this.templateUrl ? "&templateUrl=" + this.templateUrl : ""}${
              this.pageFrom ? "&pageFrom=" + this.pageFrom : ""
            }`
          );
          this.sendIframeUrlService.sendUrlToParent(this.location.path());
        }
      } else {
        onFlag = -1;
        document.title = container.title;
        this.currentSectionId = null;
        const path = `/playbookeditor/${this.playbook.id}/page/${this.currentPageId}${ratingsPath}?languageId=${this.languageId}`;
        this.location.go(
          `${path}${
            this.vBuilderRedirectURl ? "&r=" + this.vBuilderRedirectURl : ""
          }${this.templateUrl ? "&templateUrl=" + this.templateUrl : ""}${
            this.pageFrom ? "&pageFrom=" + this.pageFrom : ""
          }`
        );
        this.sendIframeUrlService.sendUrlToParent(this.location.path());
      }
    }
    container.containers.forEach((cont, index) => {
      if (onFlag == null && cont.type === 2) {
        onFlag = index;
      }
      if (cont.type === 2 && cont.id === this.currentSectionId) {
        cont.on = true;
        onFlag = -1;
        return;
      }
    });
    if (onFlag != null && onFlag !== -1 && container[onFlag]) {
      container[onFlag].on = true;
    }
  }

  /**
   * This is parent function as it handles switching on of On property
   */
  private turnOnContainers(obj: Playbook) {
    if (this.parentMap != null && this.parentMap.length !== 0) {
      this.setParentContainersOn(obj, this.parentMap);
    } else {
      obj.containers.forEach((container: Container) => {
        if (container.id === this.currentPageId) {
          container.on = true;
          this.setPageSectionsOn(container);
        }
      });
    }
  }

  /**
   * To set the page icon image and style
   */
  getIconStyle(container: Container, constPlaybook?, playbookNavigation?) {
    // TODO: To integrate ration size for this and other asset apis
    // style background url check
    // azure issue check
    if (container.customIconAssetId) {
      this.commonHttpService
        .get<any>({
          uri: `/api/Assets/Image/${container.customIconAssetId}?width=24&ratio=${this.devicePixelRatio}`,
          message: {
            showMessage: false,
          },
        })
        .subscribe((iconData) => {
          container.iconAssetStyle = {
            display: "inline-block",
            "min-height": "25px",
            "background-image": `url(\'${iconData.replace(/ /g, "%20")}\')`,
            "background-size": "24px auto",
            "background-repeat": "no-repeat",
          };
          if (playbookNavigation) {
            this.loadTreeJsonData(constPlaybook, playbookNavigation);
          }
        });
    } else {
      container.iconAssetStyle = {
        display: "inline-block",
        "min-height": "24px",
        "background-image": 'url("assets/img/dsg-page-icons-sprite.png")',
        content: "e00c",
        "background-size": "24px auto",
        "background-repeat": "no-repeat",
      };
      if (playbookNavigation) {
        this.loadTreeJsonData(constPlaybook, playbookNavigation);
      }
    }
  }

  loadTreeJsonData(constPlaybook, playbookNavigation) {
    this.customIconsLoaded++;
    if (this.customIconsLoaded === this.playbook.containers.length) {
      this.treeViewJson = this.generateTreeJson(constPlaybook, null);
      if (playbookNavigation) {
        this.openTreeView(playbookNavigation);
      }
    }
  }

  /**
   * To set passed containerId as selected page
   */
  setContainer(containerId) {
    this.commService.sendCurrentPageId(containerId);
    this.commService.sendCurrentSectionId(null);
  }

  getUrlFunc() {
    const url = this.getCompanyUrl();
    localStorage.setItem("companyUrlEditor", url);
    return url;
  }

  getCompanyUrl() {
    if (this.pageFrom && this.pageFrom === 1) {
      return `/company/${this.companyId}/templates/playbook`;
    }
    if (this.pageFrom && this.pageFrom === 2) {
      return `/templates/playbooktemplates/${this.companyId}`;
    }
    if (!this.vBuilderRedirectURl) {
      if (this.companyId) {
        if (this.templateUrl) {
          return this.templateUrl;
        }
        if (
          [
            profileRoles.administrator.toString(),
            profileRoles.playbookOwner.toString(),
            profileRoles.salesManager.toString(),
            profileRoles.user.toString(),
          ].includes(this.loggedInProfile.role)
        ) {
          return this.isCategoryId > "0"
            ? `/playbooks${
                this.playbook.categoryId
                  ? "/category/" + this.playbook.categoryId
                  : ""
              }`
            : `/playbooks`;
        }
        return this.isCategoryId > "0"
          ? `/company/${this.companyId}/playbooks${
              this.playbook.categoryId
                ? "/category/" + this.playbook.categoryId
                : ""
            }`
          : `/company/${this.companyId}/playbooks`;
      }
      return "/companies";
    } else if (this.vBuilderRedirectURl) {
      // to redirect to vBuilder if pb opened from that component
      return this.vBuilderRedirectURl;
    }
  }

  /**
   * To redirect to viewer module
   */
  redirectToViewer() {
    const route =
      window.location.pathname.replace("/playbookeditor", "/playbook") +
      window.location.search;
    this.router.navigateByUrl(route);
  }
  /**
   * To open resource ratings modal
   * @param resId resource id
   */
  openResourceRatingsModal(resId, type = 1) {
    this.commonHttpService
      .post({
        uri: "/api/Ratings/GetAllRatings",
        object: {
          id: resId,
          type,
          playbookId: this.playbookId,
          languageId: this.languageId,
          profileId: this.loggedInProfile.id,
          companyId: this.companyId,
        },
      })
      .subscribe((response: RatingData) => {
        const initialState = {
          ratingsData: response,
          playbookId: this.playbookId,
          languageId: this.languageId,
          profileId: this.loggedInProfile.id,
          role: this.loggedInProfile.role,
          containerId: response.containerId,
          ...(type === 1 && { resourceId: resId }),
          ...(type === 2 && { folderId: resId }),
          companyId: this.companyId,
          type,
        };
        this.bsResRatingsModal = this.modalService.show(
          RatingsComponent,
          Object.assign(
            { initialState },
            { class: "custom-modal" },
            Modalconfig
          )
        );

        // To change URL when opening the modal from icon click
        const href = window.location.href;
        const path = window.location.pathname;
        if (href.indexOf("resourceRatings") === -1 && type === 1) {
          const languageUrl = href.split("?")[1];
          const url = `${path}/resource/${resId}/resourceRatings?${languageUrl}`;
          this.location.go(url);
          this.sendIframeUrlService.sendUrlToParent(url);
        } else if (href.indexOf("folderRatings") === -1 && type === 2) {
          const languageUrl = href.split("?")[1];
          const url = `${path}/folder/${resId}/folderRatings?${languageUrl}`;
          this.location.go(url);
          this.sendIframeUrlService.sendUrlToParent(url);
        }
      });
  }

  /**
   * To handle reorder of containers
   * @param e cdkDragDrop event handler
   */
  onItemDrop(e: CdkDragDrop<any[]>) {
    const items = [];
    each(e.container.element.nativeElement.querySelectorAll("li"), (page) => {
      items.push(+page.id.replace("page-", ""));
    });
    moveItemInArray(items, e.previousIndex, e.currentIndex);
    const orderObj = items.map((id, index) => {
      return Object.assign({}, { id, order: index });
    });
    $(".tooltip").each(() => {
      $(this).hide();
    });
    const reqObj = {
      playbookId: this.playbook.id,
      languageId: this.languageId,
      companyId: this.playbook.companyId,
      type: 1,
      orders: orderObj,
    };
    let playbookContainers = cloneDeep(this.playbook.containers);
    forEach(this.playbook.containers, (cont) => {
      cont.orderBy = items.indexOf(cont.id);
    });
    this.commonHttpService
      .post({
        uri: "/api/containers/ReOrderContainers",
        object: reqObj,
      })
      .subscribe(
        (res) => {
          playbookContainers = [];
        },
        (error) => {
          this.playbook.containers = playbookContainers;
          playbookContainers = [];
        }
      );
  }

  /**
   * To handle add page popup
   */
  addNewPage() {
    const container = new Container();
    container.type = 1;
    container.iconClass = "1";
    const initialState = {
      container,
      verb: "Add",
      playbookId: this.playbook.id,
      companyId: this.playbook.companyId,
      profileId: this.loggedInProfile.id,
      languageId: this.languageId,
      templateUrl: this.templateUrl,
    };
    this.addPageModalRef = this.modalService.show(
      AddPageComponent,
      Object.assign({ initialState }, { class: "custom-modal " }, Modalconfig)
    );
    this.modalSubscription.push(
      this.addPageModalRef.content.addContainer.subscribe(async (data) => {
        this.getIconStyle(data);
        this.playbook.containers.push(data);
        this.unsubscribeModelsSub();
      }),
      this.addPageModalRef.content.pasteContainer.subscribe(async (data) => {
        this.getPlaybookManifest();
        this.unsubscribeModelsSub();
      })
    );
  }

  /**
   * get playbook manifest
   */
  getPlaybookManifest(undoRedoSectionData?: any) {
    if (this.playbookId) {
      this.commonHttpService
        .get<any>({
          uri: `/api/Playbooks/GetFullPlaybookManifest?playbookId=${
            this.playbookId
          }&languageId=${
            this.languageId === this.defaultLanguageId ? null : this.languageId
          }`,
        })
        .subscribe((response) => {
          const playbookData = JSON.parse(response.json);
          this.getArrayIconStyle(playbookData);
          this.commService.Playbook = playbookData;
          if (undoRedoSectionData) {
            this.isGetPlaybookData = true;
          }
          this.commService.sendCurrentPageId(
            undoRedoSectionData && undoRedoSectionData.pageId
              ? undoRedoSectionData.pageId
              : -1
          );
          this.commService.sendCurrentSectionId(
            undoRedoSectionData && undoRedoSectionData.sectionId
              ? undoRedoSectionData.sectionId
              : null
          );
          if (undoRedoSectionData) {
            document.title = undoRedoSectionData.sectionTitle
              ? undoRedoSectionData.sectionTitle
              : undoRedoSectionData.pageTitle;
            const url = `/playbookeditor/${undoRedoSectionData.playbookId}${
              undoRedoSectionData.pageId
                ? "/page/" + undoRedoSectionData.pageId
                : ""
            }${
              undoRedoSectionData.sectionId
                ? "/section/" + undoRedoSectionData.sectionId
                : ""
            }?languageId=${undoRedoSectionData.languageId}${
              this.vBuilderRedirectURl ? "&r=" + this.vBuilderRedirectURl : ""
            }${this.templateUrl ? "&templateUrl=" + this.templateUrl : ""}${
              this.pageFrom ? "&pageFrom=" + this.pageFrom : ""
            }`;
            this.location.go(url);
            if (undoRedoSectionData.languageId !== this.languageId) {
              window.location.href = window.location.origin + url;
            }
            this.sendIframeUrlService.sendUrlToParent(url);
          }
          if (undoRedoSectionData) {
            this.commService.setDraftStatus({
              pageId: undoRedoSectionData.pageId,
              isPageDraftMode: undoRedoSectionData.isDraftMode,
            });
          }
        });
    }
  }

  /**
   * To handle edit page popup
   * @param containerId update container id
   */
  editPage(containerId) {
    const selectedContainer = find(this.playbook.containers, {
      id: containerId,
    });
    const container = new Container();
    merge(container, selectedContainer);
    const initialState = {
      container,
      verb: "Edit",
      playbookId: this.playbook.id,
      companyId: this.playbook.companyId,
      languageId: this.languageId,
      profileId: this.loggedInProfile.id,
      templateUrl: this.templateUrl,
    };
    this.addPageModalRef = this.modalService.show(
      AddPageComponent,
      Object.assign({ initialState }, { class: "custom-modal " }, Modalconfig)
    );
    this.modalSubscription.push(
      this.addPageModalRef.content.updateContainer.subscribe(
        (data: Container) => {
          if (data.isPoolingNeeded) {
            this.getPlaybookManifest();
          } else {
            if (this.languageId === this.defaultLanguageId) {
              const containerIndex = findIndex(
                this.playbook.containers,
                (cont) => cont.id === data.id
              );
              this.playbook.containers[containerIndex] = {
                ...this.playbook.containers[containerIndex],
                customIconAssetId: data.customIconAssetId,
                cutomIconAsset: data.cutomIconAsset,
                iconClass: data.iconClass,
                isDeleted: data.isDeleted,
                isDraftMode: data.isDraftMode,
                isShaded: data.isShaded,
                orderBy: data.orderBy,
                title: data.title,
              };
              this.getIconStyle(this.playbook.containers[containerIndex]);
            } else {
              const containerIndex = findIndex(
                this.playbook.containers,
                (cont) => cont.id === data.id
              );
              this.playbook.containers[containerIndex].title = data.title;
            }
          }
          this.unsubscribeModelsSub();
        }
      ),
      this.addPageModalRef.content.removeContainer.subscribe((data) => {
        this.playbook.containers = reject(this.playbook.containers, (cont) => {
          return cont.id === container.id;
        });
        this.unsubscribeModelsSub();
      })
    );
  }
  isCopyPageExists() {
    this.commonHttpService
      .get({
        uri: `/api/Playbooks/IsCopyContentExists?userId=${this.loggedInProfile.id}&playbookId=${this.playbookId}`,
      })
      .subscribe((copyContentData: CopyContentExists) => {
        this.commService.setCopyContentExists(copyContentData);
      });
  }

  /**
   * To open the language selection modal
   */
  openLanguageModal() {
    const initialState = {
      playbookLanguages: this.playbookLanguages,
      languageId: this.languageId,
      playbookId: this.playbookId,
    };
    this.bsTranslationLanguageModal = this.modalService.show(
      SelectTranslationComponent,
      Object.assign(
        { initialState },
        { class: "custom-modal translation-box" },
        Modalconfig
      )
    );
    // to change url when language modal is opened
    const path = window.location.pathname;
    if (path.indexOf("selectTranslation") === -1) {
      const url = `${path}/selectTranslation${window.location.search}`;
      this.location.go(url);
      this.sendIframeUrlService.sendUrlToParent(url);
    }
  }

  /**
   * To dismiss content notification
   */
  closeAlert(data) {
    this.isContentNotification = false;
    this.commonHttpService
      .post({
        uri: "/api/ContentNotifications/DismissContentNotification",
        object: {
          playbookId: this.playbookId,
          profileId: this.loggedInProfile.id,
          contentId: this.contentId,
        },
      })
      .subscribe((success) => {});
  }

  /**
   * To open playbook custom css modal
   */
  openPlaybookCssModal() {
    const initialState = {
      playbook: this.playbook,
    };
    this.customCssRef = this.modalService.show(
      PlaybookCustomCssComponent,
      Object.assign({ initialState }, { class: "custom-modal " }, Modalconfig)
    );
  }

  /**
   * To open mail for playbook support
   */
  openSupportMail() {
    window.open("mailto:support@vplaybook.com", "_blank");
  }

  undoRedoManifest() {
    this.commService.getUndoRedoManifest().subscribe((undoRedoSectionData) => {
      this.getPlaybookManifest(undoRedoSectionData);
    });
  }

  /**
   * returns playbook viewer's url
   */
  copyViewerLinkToClipboard(): string {
    return window.location.href.replace("/playbookeditor", "/playbook");
  }
  notify(event: string): void {
    this.messageService.showSuccessMessage(
      "URL successfully copied to your clipboard."
    );
  }

  unsubscribeModelsSub() {
    this.modalSubscription.forEach((sub) => {
      sub.unsubscribe();
    });
    this.modalSubscription = [];
  }
  ngOnDestroy() {
    if (this.modalSubscription.length > 0) {
      this.unsubscribeModelsSub();
    }
    if (this.SectionIdSubscriber) {
      this.SectionIdSubscriber.unsubscribe();
    }
    if (this.PageIdSubscriber) {
      this.PageIdSubscriber.unsubscribe();
    }
    if (this.subscribed) {
      this.subscribed.unsubscribe();
    }
    if (this.resourceOnSubscriber) {
      this.resourceOnSubscriber.unsubscribe();
    }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    if (this.playbookManifestSub) {
      this.playbookManifestSub.unsubscribe();
    }
    if (this.resRatingSubscription) {
      this.resRatingSubscription.unsubscribe();
    }
    if (this.updateLanguageAfterPasteSub) {
      this.updateLanguageAfterPasteSub.unsubscribe();
    }
  }
  getCompanyData() {
    this.company = this.communicationService.getSessionStoredCompany("company");
    if (!this.playbookLanguages && this.company) {
      this.companyId = this.company.id;
      this.getPlaybookLanguages();
      this.isCopyPageExists();
    }
  }

  generateTreeJson(container: Playbook | Container, parentMap) {
    let resp = [];
    container.containers.map((container) => {
      if (container.isDraftMode) return;
      if (container.type == 1) {
        const childList = this.generateTreeJson(
          container,
          parentMap != null ? [...parentMap, container.id] : [container.id]
        );
        resp.push({
          id: container.id,
          title: container.title,
          pages: childList,
          parentMap,
          isPage: true,
          cont: cloneDeep(container),
          order: container.orderBy,
        });
      } else {
        resp.push({
          id: container.id,
          title: container.title,
          pages: [],
          parentMap:
            parentMap != null ? [...parentMap, container.id] : [container.id],
          isPage: false,
          cont: cloneDeep(container),
          order: container.orderBy,
        });
      }
    });
    return resp;
  }

  getArrayIconStyle(playbook, playbookNavigation?) {
    if (playbook && playbook.containers) {
      this.customIconsLoaded = 0;
      if (playbookNavigation) {
        this.communicationService.setShowHideLoader({
          loaderId: "simpleLoader",
          text: "",
          isShow: true,
        });
        const constPlaybook = cloneDeep(playbook);
        forEach(constPlaybook.containers, (container) => {
          this.getIconStyle(container, constPlaybook, playbookNavigation);
        });
      } else {
        forEach(playbook.containers, (container) => {
          this.getIconStyle(container);
        });
      }
    }
  }

  openTreeView(templateRef) {
    if (
      (this.selectedNavigationPage.id == null &&
        this.selectedNavigationPage.parentMap == null) ||
      (this.selectedNavigationPage.parentMap.length &&
        this.selectedNavigationPage.id !== this.currentSectionId)
    ) {
      this.selectedNavigationPage = {
        id: this.currentSectionId,
        page: null,
        parentMap:
          this.parentMap == null || this.parentMap == "NOPARENT"
            ? [this.currentPageId, this.currentSectionId]
            : [...this.parentMap, this.currentPageId, this.currentSectionId],
      };
    }
    localStorage.setItem("isSearchOpenedEditor", "true");
    this.navigationModal = this.modalService.show(
      templateRef,
      Object.assign({}, { class: "custom-modal translation-box" }, Modalconfig)
    );
    setTimeout(() => {
      const leftPos = $(".playbook-navigation")[0].scrollWidth;
      $(".playbook-navigation").animate({ scrollLeft: leftPos }, 300);
      this.communicationService.setShowHideLoader({
        loaderId: "simpleLoader",
        text: "",
        isShow: false,
      });
    }, 100);
  }
  selectPage(page) {
    this.selectedNavigationPage = {
      id: page.id,
      page: page,
      parentMap: !page.isPage
        ? cloneDeep(page.parentMap)
        : page.parentMap != null
        ? [...page.parentMap, page.id]
        : [page.id],
    };
    setTimeout(() => {
      const leftPos = $(".playbook-navigation")[0].scrollWidth;
      $(".playbook-navigation").animate({ scrollLeft: leftPos }, 300);
    }, 100);
  }
  checkNavigationView(id) {
    const resp =
      id == null ||
      (this.selectedNavigationPage.parentMap &&
        this.selectedNavigationPage.parentMap.indexOf(id) !== -1);
    return resp;
  }
  closeNavigationModal() {
    this.navigationModal.hide();
    this.navigationModal = null;
    setTimeout(() => {
      localStorage.setItem("isSearchOpenedEditor", "false");
    }, 100);
  }

  openSelectedNavigation() {
    if (
      !(
        this.selectedNavigationPage.id == this.currentSectionId ||
        this.selectedNavigationPage.id == this.currentPageId
      )
    ) {
      if (this.selectedNavigationPage.page.isPage) {
        this.commService.sendCurrentPageId(this.selectedNavigationPage.id);
        this.commService.sendCurrentSectionId(null);
        this.location.go(
          `/playbook/${this.playbookId}/page/${this.selectedNavigationPage.id}?languageId=${this.languageId}`
        );
        this.sendIframeUrlService.sendUrlToParent(this.location.path());
      } else {
        const previousId = this.commService.getCurrentIds();
        this.commService.sendCurrentPageId(
          this.selectedNavigationPage.parentMap[
            this.selectedNavigationPage.parentMap.length - 2
          ]
        );
        this.commService.sendCurrentSectionId(this.selectedNavigationPage.id);
        const currentId = this.commService.getCurrentIds();
        this.location.go(
          `/playbook/${this.playbookId}/page/${
            this.selectedNavigationPage.parentMap[
              this.selectedNavigationPage.parentMap.length - 2
            ]
          }/section/${this.selectedNavigationPage.id}?languageId=${
            this.languageId
          }`
        );
        this.sendIframeUrlService.sendUrlToParent(this.location.path());
        if (previousId.currentPageId === currentId.currentPageId) {
          this.commService.sendSamePageRedirect(currentId.currentSectionId);
        }
      }
    }
    this.closeNavigationModal();
  }

  clearSelectedEditor(isHideContentBox) {
    this.commService.sendSelectedContentBlockId(null);
    this.commService.sendSelectedRowId(null);
    if (isHideContentBox) {
      this.commService.sendSelectedContentBox(false);
    }
    this.localStorageService.clearLocalStogareByKey("isCategoryRedirect");
  }

  //Dimitrije: 28.12.2023

  getCoverBrandImage(assetId: number, field = "brandAsset") {
    if (!this.playbook || !assetId) {
      return ``;
    }

    return `/api/Assets/Image/${assetId}${
      field === "brandAsset" || field === "mobileBrandAsset"
        ? `?height=175&ratio=${this.devicePixelRatio}`
        : ""
    }`;
  }

  private loadedImages = {
    coverAsset: false,
    brandAsset: false,
    mobileCoverAsset: false,
    mobileBrandAsset: false,
  };
  onLoadImage(e) {
    this.loadedImages[e] = true;
    this.checkAllLoaded();
  }

  checkAllLoaded() {
    if (
      this.loadedImages.brandAsset &&
      this.loadedImages.coverAsset &&
      this.loadedImages.mobileBrandAsset &&
      this.loadedImages.mobileCoverAsset
    ) {
      this.collapseWithDelay();
    }
  }

  collapseWithDelay() {
    this.collapseTimeoutId = setTimeout(() => {
      this.isSidebarCollapsed = true;
    }, 1500);
  }

  private collapseTimeoutId: ReturnType<typeof setTimeout>;
  onUncollapseSidebar() {
    clearTimeout(this.collapseTimeoutId);
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
    this.collapseTimeoutId = setTimeout(() => {
      this.isSidebarCollapsed = true;
    }, 5000);
  }

  private _isSidebarCollapsed: boolean = false;
  get isSidebarCollapsed() {
    return this._isSidebarCollapsed;
  }
  set isSidebarCollapsed(value: boolean) {
    if (this._isSidebarCollapsed !== value) {
      if (
        window.innerWidth > 540 &&
        window.innerWidth < 767 &&
        this.currentPageId
      ) {
        this._isSidebarCollapsed = false;
      } else {
        this._isSidebarCollapsed = value;
      }
    }
  }
}
